import React from 'react'
import TopMenuItem from './TopMenuItem'
import { ScrollableList } from 'components'
// import ScrollY from 'components/ScrollY/ScrollY'
// import ScrollChecker from './ScrollChecker'
// import s from './TopMenu.module.css'
import * as Select from '@radix-ui/react-select'
import { Region } from 'components/common/types'
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io'
import { useRouter } from 'next/router'

type Props = {
  selectedRegion: Region
  regions: Region[]
}

const TopMenu = ({
  regionSlug,
  serviceSlug,
  regions,
  services,
  selectedRegion
}: Props) => {
  const router = useRouter()
  const serviceItems = services?.map((item) => (
    <TopMenuItem
      key={item.id}
      url={`/services/${regionSlug}/${item.slug}`}
      isSelected={item.slug === serviceSlug}
      data={item}
    />
  ))

  return (
    <div className={!serviceItems.length ? 'hidden xl:block' : ''}>
      <div className="min-h-[95px]">
        <div className="flex relative items-center border-b border-gray-200 border-solid overflow-hidden bg-white">
          <ScrollableList services={services} items={serviceItems}>
            <Select.Root
              value={selectedRegion.slug}
              onValueChange={(regionValue) => {
                const foundRegion = regions.find(
                  (region) => region.slug === regionValue
                )

                const url = foundRegion?.services?.length
                  ? `/services/${foundRegion.slug}/${foundRegion.services[0].slug}`
                  : `/services/${foundRegion.slug}`

                router.push(url, undefined, {
                  shallow: true,
                  scroll: true
                })
              }}
            >
              <Select.Trigger className="text-3xl  items-center no-underline bg-white mr-12 cursor-pointer hidden xl:flex">
                <Select.Value />

                <IoIosArrowDown className="ml-2" />
              </Select.Trigger>
              <Select.Portal>
                <Select.Content className="SelectContent">
                  <Select.ScrollUpButton className="SelectScrollButton">
                    <IoIosArrowUp />
                  </Select.ScrollUpButton>
                  <Select.Viewport className="SelectViewport">
                    <Select.Group className="flex flex-col gap-y-1">
                      {regions.map((region) => (
                        <SelectItem value={region.slug}>
                          {region.name}
                        </SelectItem>
                      ))}
                    </Select.Group>
                  </Select.Viewport>
                </Select.Content>
              </Select.Portal>
            </Select.Root>
          </ScrollableList>
        </div>
      </div>
    </div>
  )
}

const SelectItem = React.forwardRef(
  ({ children, className, isSelected, ...props }, forwardedRef) => {
    return (
      <Select.Item className="SelectItem" {...props} ref={forwardedRef}>
        <Select.ItemText>{children}</Select.ItemText>
      </Select.Item>
    )
  }
)

export default TopMenu
